// Module
var code = "<react-component name=\"ContactFlagsReport\"></react-component>\n";
// Exports
module.exports = code;